module.exports = __webpack_public_path__ + "img/5aMint1Button.f4cd2ccc.png";